import EventEmitter from 'eventemitter3';

export interface AppEvent {
  'user:logout': void;
}

const appEvents = new EventEmitter<AppEvent>();

export default appEvents;
